import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function UpsideArrow(props: any) {
    return (
        <Svg
            width={props.size || 10}
            height={props.size || 8}
            viewBox='0 0 12 8'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
            <Path
                d='M5.99985 0.925187C6.09985 0.925187 6.19152 0.941854 6.27485 0.975187C6.35818 1.00852 6.44152 1.06685 6.52485 1.15019L11.4749 6.10019C11.6082 6.23352 11.6707 6.41269 11.6624 6.63769C11.654 6.86269 11.5832 7.04185 11.4499 7.17519C11.2832 7.34185 11.104 7.41269 10.9124 7.38769C10.7207 7.36269 10.5499 7.28352 10.3999 7.15019L5.99985 2.75019L1.59985 7.15019C1.46652 7.28352 1.28735 7.35852 1.06235 7.37519C0.83735 7.39185 0.658183 7.31685 0.52485 7.15019C0.358183 7.01685 0.287351 6.84185 0.31235 6.62519C0.33735 6.40852 0.416516 6.22519 0.54985 6.07519L5.47485 1.15019C5.55819 1.06685 5.64152 1.00852 5.72485 0.975187C5.80819 0.941853 5.89985 0.925187 5.99985 0.925187Z'
                fill={props.color || '#000'}
            />
        </Svg>
    );
}

export default UpsideArrow;
